import React, { useCallback, useEffect } from 'react';

import { Portal } from '@ariakit/react';

import * as classes from './style.module.scss';

interface Props {
  visible: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export const Backdrop: React.FC<Props> = ({ visible, onClick, ...props }) => {
  const handleResize = useCallback(
    event => {
      if (visible && onClick) onClick(event);
    },
    [visible, onClick],
  );

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return (
    visible && <Portal {...props} onClick={onClick} className={classes.root} />
  );
};
